import CheckboxField from '@/base/Form/CheckboxField';
import { useTheme } from '@chakra-ui/react';
import type React from 'react';

interface Props {
  policyText: string
  policyUrl: string
  checkboxName: string
}

const PolicyCheckBox: React.FC<Props> = ({ checkboxName, policyText, policyUrl }) => {
  const theme = useTheme();
  const primaryColor = theme.colors.primary[500];
  const textColor = theme.colors.text.primary;

  const richText = `
    <span style="color: ${textColor};">
      I have read and agree to the 
    </span>
    <a href="${policyUrl}" target="_blank" style="color: ${primaryColor};">
      ${policyText}
    </a>
  `;
  return (
    <CheckboxField name={checkboxName}>
      <div dangerouslySetInnerHTML={{ __html: richText }} />
    </CheckboxField>
  );
};

export default PolicyCheckBox;
